{
  "page_title": "Additional Services",
  "calendar": {
    "make_booking": "Make a booking",
    "service": "Service",
    "inactive": "Inactive",
    "no_units": "No services",
    "failed_to_load": "Failed to load calendar",
    "prev_day": "Previous day",
    "next_day": "Next day",
    "margin": "Booking margin",
    "collapse_panel": "Collapse panel",
    "expand_panel": "Expand panel",
    "show_group": "Show {{name}}",
    "hide_group": "Hide {{name}}",
    "booking": {
      "title": "New booking",
      "mode_label": "Booking method",
      "single_tab": "Single booking",
      "batch_tab": "Batch booking",
      "type_label": "Booking type",
      "type": {
        "service": "Service",
        "competition": "Competition",
        "tee_time": "Tee time",
        "other": "Other"
      },
      "group_label": "Service group",
      "unit_label": "Service",
      "unit_placeholder_single": "Select a service",
      "unit_placeholder_batch": "Select services",
      "selected_count": "{{count}} / {{total}} selected",
      "select_all_free": "Select all available",
      "no_units": "No services",
      "status_free": "Available",
      "status_busy": "Booked",
      "start": "Starts",
      "end": "Ends",
      "duration_label": "Duration",
      "holes9": "9 holes ({{min}} min)",
      "holes18": "18 holes ({{min}} min)",
      "notes": "Additional information",
      "notes_placeholder": "E.g. customer name",
      "submit": "Make booking",
      "created": "Booking created",
      "save_failed": "Failed to save booking",
      "availability_failed": "Failed to load availability",
      "times_required": "Please select a start and end time",
      "invalid_window": "End time must be after start time",
      "type_required": "Please select a booking type",
      "unit_required": "Please select a service",
      "units_required": "Please select at least one service",
      "conflict_row": "{{unit}}: {{start}}–{{end}}",
      "overlap_warning": "This booking overlaps with an existing booking."
    },
    "reservation": {
      "edit": "Edit",
      "edit_title": "Edit reservation",
      "updated": "Reservation updated",
      "update_failed": "Failed to update reservation",
      "delete": "Delete",
      "delete_confirm_header": "Delete reservation",
      "delete_confirm_body": "Are you sure you want to delete the reservation {{name}}?",
      "delete_scope_single": "This reservation only",
      "delete_scope_batch": "All reservations in this batch",
      "deleted": "Reservation deleted",
      "batch_deleted": "Batch reservations deleted",
      "delete_failed": "Failed to delete reservation"
    },
    "resize": {
      "saved": "{{unit}}: reservation time updated",
      "undo_failed": "Undo failed"
    },
    "prev_week": "Previous week",
    "next_week": "Next week",
    "view_mode_label": "Calendar view",
    "view_day": "Day",
    "view_week": "Week",
    "pick_date": "Select date",
    "show_day": "Show day view"
  },
  "serviceGroups": {
    "panel_title": "Service groups",
    "empty": {
      "heading": "No service groups",
      "description": "Service groups allow you to manage rentable add-on services, such as golf carts, bags and trolleys.",
      "add_button": "Add service group"
    },
    "add_group_short": "Group",
    "failed_to_load": "Failed to load service groups",
    "activate": "Activate {{name}}",
    "deactivate": "Deactivate {{name}}",
    "list": {
      "name": "Name",
      "active": "Active",
      "yes": "Yes",
      "no": "No"
    },
    "card": {
      "actions_aria": "Actions for service group {{name}}",
      "in_use": "In use",
      "yes": "Yes",
      "no": "No",
      "duration": "Duration",
      "margin": "Margin",
      "holes9": "9h",
      "holes18": "18h",
      "before": "before",
      "after": "after",
      "min": "min"
    },
    "form": {
      "create_title": "New service group",
      "edit_title": "Edit service group",
      "section_title": "Service group settings",
      "name": "Name",
      "icon": "Group icon",
      "icons": {
        "carFront": "Car",
        "bicycle": "Bicycle",
        "gear": "Gear",
        "star": "Star",
        "person": "Person"
      },
      "active": "Active",
      "duration9": "Reservation duration 9 holes (min)",
      "duration18": "Reservation duration 18 holes (min)",
      "margin_before": "Reservation margin before booking (min)",
      "margin_after": "Booking margin after reservation (min)",
      "terms": "Booking terms (shown to the player when making a reservation)",
      "name_required": "Name is required",
      "created": "Service group created",
      "updated": "Service group updated",
      "deleted": "Service group deleted",
      "load_failed": "Failed to load service group",
      "save_failed": "Saving failed",
      "delete_failed": "Deletion failed",
      "delete_confirm_header": "Delete service group",
      "delete_confirm_body": "Are you sure you want to delete the service group {{name}}?"
    },
    "units": {
      "section_title": "Services",
      "add_button": "Add service",
      "name": "Name",
      "active": "Active",
      "reservations": "Reservations",
      "reservations_title": "{{count}} upcoming reservations",
      "name_placeholder": "Service name",
      "save": "Save",
      "empty": "No services",
      "created": "Service created",
      "updated": "Service updated",
      "activated": "{{name}} activated",
      "deactivated": "{{name}} deactivated",
      "deleted": "Service deleted",
      "name_required": "Service name is required",
      "load_failed": "Failed to load services",
      "save_failed": "Failed to save service",
      "delete_failed": "Failed to delete service",
      "delete_confirm_header": "Delete service",
      "delete_confirm_body": "Are you sure you want to delete the service {{name}}?",
      "form": {
        "create_title": "New service",
        "edit_title": "Edit service"
      }
    }
  }
}
